export const isStagingEnvironment = () => {
  return window.location.host.includes("enrollment.staging-cap-rx");
};

export const isQAEnvironment = () => {
  return window.location.host.includes("enrollment.qa-cap-rx");
};

export const isLocalEnvironment = () => {
  return (window.location.hostname.match(/\d+\.\d+\.\d+\.\d+/) || window.location.hostname === "localhost") && window.location.port === "7050";
};

export const isDemoEnvironment = () => {
  return window.location.host.includes("enrollment.demo-cap-rx");
};


/**
 * Turn off the new plans redesign in higher environments
 */
export const enablePlansPageRedesign = () => {
  return isLocalEnvironment() || isStagingEnvironment() || isQAEnvironment() || isDemoEnvironment();
};
